
<div class="jobs" [dir]="'Direction' | translate">
    <div class="container">
      <div class="empty-space"></div>
        <!-- <div class="container">
            <h3 class="section-title">
               {{"CoreValues.Title" | translate}}
            </h3>
        </div> -->

        <div class="jobs-inner">
            <div class="text-center p-2 mx-2 head-text"> <h2>{{"CoreValues.Title"| translate}} </h2></div>
            <div class="cards-holder">
                <div class="col-3 w-50 h-25 p-2 position-relative card-container">
                    <div class="card-content">
                      <img src="assets/images/aerial-view-business-team.jpg" class="border rounded" alt="{{ 'Integrity' | translate }}">
                    </div>
                  <div class="card-text">{{ 'Integrity' | translate }}</div>
                </div>
                <div class="col-3 w-50 h-25 p-2 card-container">
                  <div class="card-content">
                    <img src="assets/images/businessman-with-light-bulb-his-hand.jpg" class="border rounded" alt="{{ 'Professionalism' | translate }}">
                  </div>
                  <div class="card-text">{{ 'Professionalism' | translate }}</div>
                </div>
                <div class="col-3 w-50 h-25 p-2 card-container">
                  <div class="card-content">
                    <img src="assets/images/businessman-talking-phone-background.jpg" class="img-fluid border rounded" alt="{{ 'Entrepreneurship' | translate }}">
                  </div>
                  <div class="card-text">{{ 'Entrepreneurship' | translate }}</div>
                </div>
                <div class="col-3 w-50 h-25 p-2 card-container">
                  <div class="card-content">
                    <img src="assets/images/standard-quality-control-concept-m.jpg" class="img-fluid border rounded" alt="{{ 'Innovation' | translate }}">
                  </div>
                  <div class="card-text">{{ 'Innovation' | translate }}</div>
                </div>
            </div>
            <p class="space-row" style="color: black;">{{ "CoreValues.Description" | translate }}</p>
        </div>
    </div>
</div>
